import Cookies from 'js-cookie'
import { baseUrl } from '@fs/zion-config'
import axios from '../axios'
import { FieldNames, Urls } from '../constants'
import { MultiValidationError, InvalidTokenError, LockedAccountError } from '../errors'
import logError from './logError'
import redirectAsync from '../utils/redirectAsync'

export default async function verifyOneTimeToken({ [FieldNames.VERIFICATION_CODE]: code }, action) {
  const urlencoded = new URLSearchParams()
  urlencoded.append('token', code)
  urlencoded.append('_csrf', Cookies.get('XSRF-TOKEN'))
  if (action) {
    urlencoded.append('action', action)
  }

  const response = await axios.post(`${window.location.origin}/login/ott`, urlencoded, {
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    xsrfCookieName: 'made-up-cookie-so-we-do-not-sent',
  })
  const { loginError, redirectUrl } = response.data || {}
  if (!loginError && !redirectUrl) {
    logError('No redirectUrl was returned in Authn login call.')
    return redirectAsync(baseUrl)
  }
  if (redirectUrl) {
    return redirectAsync(redirectUrl)
  }
  switch (loginError) {
    case 'loginOutsideOauth':
      return redirectAsync(Urls.SESSION_EXPIRED)
    case 'InvalidOneTimeTokenException':
      throw new MultiValidationError([new InvalidTokenError()])
    case 'LockedException':
      throw new MultiValidationError([new LockedAccountError()])
    case 'RateLimitException':
      throw new MultiValidationError([new LockedAccountError()])
    default: {
      const message = `Unknown login error returned ${loginError}`
      throw new Error(message)
    }
  }
}
